import Link from 'next/link'
import Markdown from 'react-markdown'

import { PageSearchApiResponse } from '@/lib/api-connector-strapi-cms/api/page-search/pageSearchApi.types'
import { Button } from '@/lib/ui-kit/components/ui/Button.component'

export const Text = ({ children }: { children?: React.ReactNode }) => {
  return (
    <h1 className="heading-l m-auto px-6 text-center font-medium xl:px-10">
      {children}
    </h1>
  )
}

export const NoResults = ({ data }: { data: PageSearchApiResponse }) => {
  return (
    <div className="border-b border-gray-400">
      <div className="flex w-full flex-col justify-center py-8">
        {data.data.pageSearch?.noResultsMessage && (
          // @ts-ignore
          <Markdown components={{ p: Text }}>
            {data.data.pageSearch?.noResultsMessage}
          </Markdown>
        )}
      </div>
      <div className="flex w-full justify-center pb-6">
        <span className="paragraph-s">{data.data.pageSearch?.tagsCaption}</span>
      </div>
      <div className="w-max-[650px] flex flex-wrap items-center justify-center pb-12 xl:pb-20">
        {data.data.pageSearch?.tags?.data &&
          data.data.pageSearch?.tags?.data.map((tag) => (
            <Link href={`/blog/topic/${tag.linkTag}`} key={tag.tag}>
              <Button className="mb-2 mr-2" variant="secondary">
                {tag.tag}
              </Button>
            </Link>
          ))}
      </div>
    </div>
  )
}
